module.exports = __webpack_public_path__ + "img/indoors.bfbb3d48.jpg";